/* src/app/layout/components/routemagic-assistant/agent-ccp-widget/agent-ccp-widget.component.scss */
.ccp-container {
  --chat-button-color: var(--orange);
  --chat-header-bg-color: var(--orange);
}
.ccp-container .iframe-container {
  position: relative;
  right: 0px;
  top: 10px;
  z-index: 5;
  height: 100%;
}
.ccp-container .iframe-container iframe {
  display: none;
}
.ccp-container .ccp-widget {
  position: fixed;
  right: 0px;
  bottom: 50px;
  height: 75%;
  z-index: 6;
  background: #fff;
}
.ccp-container .ccp-widget-container {
  height: 100%;
}
.ccp-container .acOpenButton {
  color: white;
  background-color: var(--chat-button-color);
  position: fixed;
  bottom: 20px;
  right: 10px;
}
.ccp-container .acCloseButton {
  color: white;
  background-color: var(--chat-button-color);
  display: none;
  position: fixed;
  bottom: 20px;
  right: 10px;
}
.ccp-container .acButtonStyles {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  border: none;
  float: right;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  outline: none;
  cursor: pointer;
  transition: background-color 0.5s ease;
  z-index: 10;
}
.ccp-container .hide {
  display: none !important;
}
.ccp-container .show {
  display: inline !important;
}
/*# sourceMappingURL=data:application/json;base64,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 */
